import DeliveryAddresses from '../../../../../components/Sales/Client/Contract/Form/DeliveryAddresses'
import React, { Component, Fragment } from 'react'
import { Breadcrumb, Button, Card, Popconfirm, Row, Steps, Tooltip } from 'antd'
import Overview from '../Form/Overview'
import KeyTerms from '../Form/KeyTerms'
import Payment from '../Form/Payment'
import Communication from '../Form/Communication'
import { assign, get, isEmpty, omit, set } from 'lodash'
import style from './style.css'
import Rates from '../Form/Rates'
import useTitle from '../../../../../elements/Hooks/useTitle'

const Step = Steps.Step

function AddContract(props) {
  const titles = {
    new: 'Create new Client Account',
    update: 'Update Client Account',
  }
  const descriptions = {
    new: 'You can add new Client Account by following the steps below.',
    update: 'You need to follow the steps below to update Client Account.',
  }
  const {
    member,
    client,
    memberFetching,
    submitting,
    contract,
    current,
    showSkip,
    submit,
    update,
    updateContract,
    communicationCmpRef,
    key,
    type,
    prev,
    next,
    skip,
    overviewCmpRef,
    keyTermsCmpRef,
    payrollCmpRef,
    ratesCmpRef,
    deliveryCmpRef,
  } = props
  useTitle(type === 'update' ? `Update ${contract.code}` : 'Create new Account')

  const submitButton = {
    new: (
      <Popconfirm title="Sure to submit?" onConfirm={() => submit()}>
        <Button loading={submitting} type="primary">
          Submit
        </Button>
      </Popconfirm>
    ),
    update: (
      <Popconfirm title="Sure to Update?" onConfirm={() => update()}>
        <Button loading={submitting} type="primary">
          Update
        </Button>
      </Popconfirm>
    ),
  }

  console.log(333, contract)

  let steps = [
    {
      title: 'Account Overview',
      content: <Overview {...props} client={client} contract={contract} ref={overviewCmpRef} />,
      key: 'overview',
    },
    {
      title: 'Key Terms',
      content: <KeyTerms client={client} updateContract={updateContract} ref={keyTermsCmpRef} contract={contract} />,
      key: 'keyTerms',
    },
    {
      title: 'Billing & Payment',
      content: <Payment updateContract={updateContract} client={client} contract={contract} ref={payrollCmpRef} />,
      key: 'payroll',
    },
    {
      title: 'Communication',
      content: (
        <Communication
          updateContract={updateContract}
          client={client}
          member={member}
          type={type}
          ref={communicationCmpRef}
          contract={contract}
        />
      ),
      key: 'communication',
    },
    {
      title: 'Rates',
      content: (
        <Rates updateContract={updateContract} client={client} type={type} ref={ratesCmpRef} contract={contract} />
      ),
      key: 'rates',
    },
    {
      title: 'Delivery Addresses',
      content: <DeliveryAddresses contract={contract} ref={deliveryCmpRef} updateContract={updateContract} />,
      key: 'delivery',
    },
  ]
  return (
    <Fragment>
      <Card>
        <Row className={style.pageHeader}>
          <Breadcrumb>
            <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
            <Breadcrumb.Item>Sales</Breadcrumb.Item>
            <Breadcrumb.Item href="#/clients/list">Clients List</Breadcrumb.Item>
            <Breadcrumb.Item href={`#/clients/${member._key}/#contracts`}>{member.fn}</Breadcrumb.Item>
            {type === 'update' && (
              <Breadcrumb.Item href={`#/clients/${key}/contracts/${contract._key}/view`}>
                {contract.code}
              </Breadcrumb.Item>
            )}
          </Breadcrumb>
          <h2 className={style.title}>{titles[type]}</h2>
          <p className={style.paragraph}>{descriptions[type]}</p>
        </Row>
      </Card>
      <Card loading={memberFetching} className={style.contentCard}>
        <Steps current={current}>
          {steps.map((item) => (
            <Step key={item.key} title={item.title} />
          ))}
        </Steps>
        <div style={{ marginTop: '50px', marginBottom: '10px' }} className="steps-content">
          {steps[current].content}
        </div>
        <div className="steps-action" style={{ textAlign: 'center', paddingTop: 20 }}>
          {current > 0 && (
            <Button style={{ marginRight: 8 }} onClick={() => prev()}>
              Previous
            </Button>
          )}
          {current < steps.length - 1 && (
            <Button style={{ width: '100px' }} type="primary" onClick={() => next()}>
              Next
            </Button>
          )}
          {current < steps.length - 1 && showSkip && (
            <Tooltip title="Skip validation for now">
              <Button icon="double-right" shape="dashed" style={{ marginLeft: 10 }} onClick={() => skip()} />
            </Tooltip>
          )}
          {current === steps.length - 1 &&
            (submitButton[type] || (
              <Popconfirm title="Sure to submit?" onConfirm={() => submit()}>
                <Button loading={submitting} type="primary">
                  Submit
                </Button>
              </Popconfirm>
            ))}
        </div>
      </Card>
    </Fragment>
  )
}

export default AddContract
